import { isPlatform } from "@ionic/react";
import { Capacitor } from "@capacitor/core";

const isNative = Capacitor.isNativePlatform(); // isNative is for capacitor (maybe more accurate)
const iosOrAndroid = isPlatform("hybrid"); // isPlatform("hybrid") is for ionic (its possible for ipad its fails)

// isRunningNatively is for capacitor and ionic (even more accurate)
const isRunningNatively = isNative || iosOrAndroid;
console.log("isNative from Capacitor/core", isNative);
console.log("iosOrAndroid from Ionic/react", iosOrAndroid);
console.log("isRunningNatively", isRunningNatively);

// const appId = "com.rotogpt.chat";
const appId = "com.rotogpt.chat";
const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const frontendUriWeb = process.env.REACT_APP_FRONTEND_URI_WEB;

//Get callback if is web or not
export const callbackUri = isRunningNatively ? `${appId}://${auth0Domain}/capacitor/${appId}/callback` : frontendUriWeb; // for web
